import { SearchApi } from '@backstage/plugin-search-react';
import {
  SearchQuery,
  SearchResultSet,
} from '@backstage/plugin-search-common';
import {
  DiscoveryApi,
  FetchApi,
  IdentityApi,
} from '@backstage/core-plugin-api';

export class TenantAwareSearchClient implements SearchApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;
  private readonly identityApi: IdentityApi;

  constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
    identityApi: IdentityApi;
  }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
    this.identityApi = options.identityApi;
  }

  async query(query: SearchQuery): Promise<SearchResultSet> {
    const details = await this.identityApi.getBackstageIdentity();
    const tenantId = details.ownershipEntityRefs.find(ref =>
      ref.startsWith('tenantId:'),
    )?.split(':')[1];
    const role = details.ownershipEntityRefs.find(ref =>
      ref.startsWith('role:'),
    )?.split(':')[1];

    console.log("tenant id is-----------------", tenantId)
    const baseUrl = await this.discoveryApi.getBaseUrl('search');
    const url = new URL(`${baseUrl}/query`);

    // Add search term if present
    if (query.term) {
      url.searchParams.set('term', query.term);
    }

    // Always inject tenantId
    if ( role != 'SuperAdmin'){
      if (tenantId) {
          url.searchParams.append('filters[tenantId]', tenantId);

      }}
    // Preserve any other filters
    if (query.filters) {
        for (const [key, value] of Object.entries(query.filters)) {
          const values = Array.isArray(value) ? value : [value];
          values.forEach(v => {
            if (v !== undefined && v !== null) {
              url.searchParams.append(`filters[${key}]`, String(v));
            }
          });
        }
      } 
    const response = await this.fetchApi.fetch(url.toString());
    if (!response.ok) {
      throw new Error(`Search request failed: ${response.statusText}`);
    }
    return await response.json();
  }
}
